import React from 'react';
import { I18n } from 'aws-amplify';
import {MAX_STEPS} from '../../configures/val.js';

export default function Stepper(props) {
  function getRemainStr () {
    let ret = Math.abs(Number(props.nowStatus.slice(0, -1)) / (100/MAX_STEPS) - MAX_STEPS);
    switch(ret) {
      case 1:
        return I18n.get('Registration will be done with few more steps');
      case 0:
        return I18n.get('Press Enter to complete your registration');
      default:
        return I18n.get('Remaining steps') + ret;
    }
  }

  return (
    <div className="stepper">
      <div className="stepperBack">
        <div style={{width:props.nowStatus}} className="stepperProgress"></div>
      </div>
      <p className="colNatural02">{getRemainStr()}</p>
    </div>
  ); 
}
